// values are the error keys of server side module class-validation, which will be sent via graphql
export const GraphQLInputError = {
    INVALID_EMAIL: 'isEmail',
};
